import { ModulesMap } from '@/config/data/modulesMaps'

import ApiModule from '@/services/apiModule.js'

export default class StaffDepartmentsApi extends ApiModule {
	constructor() {
		super(ModulesMap.STAFF_DEPARTMENTS, {
			entity: 'staff_departments',
		})
	}
}
